import React, { useState, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../styles/partials/accordion.module.scss';

const propTypes = {
    children: PropTypes.node,
    label: PropTypes.node,
    iconComponent: PropTypes.node,
    initialOpened: PropTypes.bool,
    className: PropTypes.string,
    isOpenClassName: PropTypes.string,
    titleClassName: PropTypes.string,
    toggleClassName: PropTypes.string,
    itemWrapperClassName: PropTypes.string,
    childrenClassName: PropTypes.string,
};

const defaultProps = {
    children: null,
    label: null,
    iconComponent: null,
    initialOpened: false,
    className: null,
    isOpenClassName: null,
    titleClassName: null,
    toggleClassName: null,
    itemWrapperClassName: null,
    childrenClassName: null,
};

const Accordion = ({
    children,
    iconComponent,
    label,
    initialOpened,
    className,
    isOpenClassName,
    titleClassName,
    toggleClassName,
    itemWrapperClassName,
    childrenClassName,
}) => {
    const accordionRef = useRef(null);
    const [accordionOpened, setAccordionOpened] = useState(initialOpened);

    const openItem = useCallback(
        (e) => {
            e.preventDefault();
            setAccordionOpened(!accordionOpened);
        },
        [accordionOpened, setAccordionOpened],
    );

    const { height: itemHeight } =
        accordionRef.current !== null ? accordionRef.current.getBoundingClientRect() : 0;

    const maxHeight = `${accordionOpened ? itemHeight : '0'}px`;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [isOpenClassName]: isOpenClassName !== null && accordionOpened,
                },
            ])}
        >
            <h2
                className={classNames(styles.title, {
                    [titleClassName]: titleClassName !== null,
                })}
            >
                <button
                    className={classNames(styles.toggle, {
                        [toggleClassName]: toggleClassName !== null,
                        [styles.collapsed]: accordionOpened,
                    })}
                    type="button"
                    onClick={openItem}
                >
                    {label}
                    <span className={styles.button}>{iconComponent !== null && iconComponent}</span>
                </button>
            </h2>
            <div
                className={classNames(styles.itemWrapper, {
                    [itemWrapperClassName]: itemWrapperClassName !== null,
                })}
                style={{ maxHeight }}
            >
                <div
                    ref={accordionRef}
                    className={classNames(styles.children, {
                        [childrenClassName]: childrenClassName !== null,
                    })}
                >
                    {children}
                </div>
            </div>
        </div>
    );
};

Accordion.propTypes = propTypes;
Accordion.defaultProps = defaultProps;

export default Accordion;
